<template>
  <div class="subscription-config-container">
    <div class="subscription-config-content">
      <div class="subscription-config-header">
        <h2>订阅方案设置</h2>
        <p>配置用户的订阅方案和权益</p>
      </div>

      <div class="plans-table">
        <div class="plans-table-header">
          <span class="col-id">ID</span>
          <span class="col-name">名称</span>
          <span class="col-price">价格</span>
          <span class="col-period">周期</span>
          <span class="col-quota">月度次数</span>
          <span class="col-daily">每日限制</span>
          <span class="col-models">模型</span>
          <span class="col-watermark">水印</span>
          <span class="col-api">API</span>
          <span class="col-featured">推荐</span>
          <span class="col-enabled">启用</span>
          <span class="col-actions">操作</span>
        </div>
        
        <div class="plan-row" v-for="plan in plans" :key="plan.id">
          <span class="col-id">{{ plan.id }}</span>
          <el-input v-model="plan.name" size="mini" class="col-name" />
          <el-input-number v-model="plan.price" :min="0" :step="1" size="mini" class="col-price" />
          <el-select v-model="plan.period" size="mini" class="col-period">
            <el-option label="永久" value="永久" />
            <el-option label="月" value="月" />
            <el-option label="年" value="年" />
          </el-select>
          <el-input-number v-model="plan.monthly_quota" :min="-1" :step="100" size="mini" class="col-quota" />
          <el-input-number v-model="plan.daily_limit" :min="0" :step="1" size="mini" class="col-daily" />
          <el-select v-model="plan.models_access" size="mini" class="col-models">
            <el-option label="基础" value="basic" />
            <el-option label="全部" value="all" />
          </el-select>
          <el-switch v-model="plan.watermark" size="mini" class="col-watermark" />
          <el-switch v-model="plan.api_access" size="mini" class="col-api" />
          <el-switch v-model="plan.featured" size="mini" class="col-featured" />
          <el-switch v-model="plan.enabled" size="mini" class="col-enabled" />
          <span class="col-actions">
            <div class="actions-wrapper">
              <el-button size="mini" @click="editPlanDetail(plan)">详情</el-button>
              <el-button size="mini" type="primary" @click="savePlan(plan)">保存</el-button>
            </div>
          </span>
        </div>
      </div>

      <div class="plan-detail-section" v-if="editingPlan">
        <el-divider content-position="left">详细设置 - {{ editingPlan.name }}</el-divider>
        
        <el-form :model="editingPlan" label-width="150px" size="small">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="方案描述">
                <el-input v-model="editingPlan.description" type="textarea" :rows="3" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="按钮文字">
                <el-input v-model="editingPlan.button_text" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="排序">
                <el-input-number v-model="editingPlan.sort_order" :min="0" :step="1" />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item>
            <el-button type="primary" @click="savePlanDetail">保存详细设置</el-button>
            <el-button @click="editingPlan = null">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="config-actions">
        <el-button @click="loadPlans">刷新</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SubscriptionConfig',
  data() {
    return {
      plans: [],
      editingPlan: null
    }
  },
  mounted() {
    this.loadPlans()
  },
  methods: {
    async loadPlans() {
      try {
        const response = await axios.get('/admin/subscription/plans')
        if (response.data.code === 200) {
          this.plans = response.data.data
        }
      } catch (error) {
        console.error('加载订阅方案失败:', error)
        this.$message.error('加载订阅方案失败')
      }
    },
    async savePlan(plan) {
      try {
        const response = await axios.post('/admin/subscription/plans', {
          id: plan.id,
          name: plan.name,
          description: plan.description,
          price: plan.price,
          period: plan.period,
          monthly_quota: plan.monthly_quota,
          daily_limit: plan.daily_limit,
          max_image_size: plan.max_image_size,
          max_video_duration: plan.max_video_duration,
          models_access: plan.models_access,
          watermark: plan.watermark,
          priority_queue: plan.priority_queue,
          api_access: plan.api_access,
          max_concurrent: plan.max_concurrent,
          support_level: plan.support_level,
          featured: plan.featured,
          button_text: plan.button_text,
          enabled: plan.enabled,
          sort_order: plan.sort_order
        })
        if (response.data.code === 200) {
          this.$message.success(`${plan.name} 保存成功`)
          this.loadPlans()
        } else {
          this.$message.error(response.data.message || '保存失败')
        }
      } catch (error) {
        console.error('保存订阅方案失败:', error)
        this.$message.error('保存失败')
      }
    },
    editPlanDetail(plan) {
      this.editingPlan = { ...plan }
    },
    async savePlanDetail() {
      if (!this.editingPlan) return
      await this.savePlan(this.editingPlan)
      this.editingPlan = null
    }
  }
}
</script>

<style scoped>
.subscription-config-container {
  padding: 20px 0;
}

.subscription-config-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.subscription-config-header {
  margin-bottom: 30px;
}

.subscription-config-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.subscription-config-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.plans-table {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
}

.plans-table-header,
.plan-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  gap: 8px;
}

.plans-table-header {
  background: #f5f5f5;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.plan-row {
  background: #fff;
}

.plan-row:hover {
  background: #f9f9f9;
}

.plan-row:last-child {
  border-bottom: none;
}

.col-id { width: 80px; font-size: 12px; color: #666; }
.col-name { width: 100px; }
.col-price { width: 90px; }
.col-period { width: 80px; }
.col-quota { width: 100px; }
.col-daily { width: 100px; }
.col-models { width: 80px; }
.col-watermark { width: 60px; }
.col-api { width: 60px; }
.col-featured { width: 60px; }
.col-enabled { width: 60px; }
.col-actions { width: 160px; display: flex; align-items: center; justify-content: center; }
.actions-wrapper { display: flex; gap: 8px; }

.plan-detail-section {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 20px;
}

.config-actions {
  text-align: right;
}

.el-divider {
  color: #333;
  font-weight: 600;
}
</style>
